"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFormControlLabel = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const StyledFormControlLabel = _ref => {
  let {
    option
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
    value: option.key,
    control: /*#__PURE__*/_react.default.createElement(_material.Radio, {
      icon: /*#__PURE__*/_react.default.createElement("svg", {
        width: "19",
        height: "18",
        viewBox: "0 0 19 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("circle", {
        cx: "9.5",
        cy: "9",
        r: "8.5",
        stroke: "#212121"
      })),
      checkedIcon: /*#__PURE__*/_react.default.createElement("svg", {
        width: "19",
        height: "18",
        viewBox: "0 0 19 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("circle", {
        cx: "9.5",
        cy: "9",
        r: "8.5",
        stroke: "#212121"
      }), /*#__PURE__*/_react.default.createElement("circle", {
        cx: "9.5",
        cy: "9",
        r: "6",
        fill: "#4086FF"
      })),
      sx: {
        color: "var(--color-custom-black)",
        marginLeft: "-5px",
        marginRight: "-5px"
      }
    }),
    label: option.label,
    sx: {
      "&:last-child": {
        marginRight: "0px"
      }
    }
  });
};
exports.StyledFormControlLabel = StyledFormControlLabel;